import { useLocation, useNavigate } from "react-router";
import Styles from "./User.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Formik } from "formik";
import CustomField from "../../components/shared/CustomTextField";
import {
  Alert,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  stackClasses,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  deleteDrivingTime,
  deleteUser,
  deleteUserToGroup,
  getDrivingTime,
  postUserToGroup,
  updateUser,
} from "../../utils/API/userMethods";
import { useStore } from "../../hooks/store";
import { baseUrl, userRole } from "../../utils/config";
import PasswordResetFrom from "../../components/Form/PasswordRestoreForm";
import {
  getCategory,
  getSchoolGroup,
  getStudentImage,
} from "../../utils/API/schoolMethods";
import ReactCalendar from "../../components/ReactCalendar";
import { AgGridReact } from "ag-grid-react";
import GridToolBar from "../../components/GridToolBar";
import {
  defaultColDef,
  DrivingTimeColumn,
  getRowId,
  getUserRowStyle,
} from "../../utils/gridHelper";
import DrivingTimeForm from "../../components/Form/DrivingTimeForm";
import { getToken } from "../../utils/API/authMethods";

export default function UserRedactPage() {
  const { state } = useLocation();
  const store = useStore();
  const [dates, setDates] = useState({
    birthday: state.birthday || null,
    passport_issued_date: state.passport_issued_date || null,
    med_cert_issued_date: state.med_cert_issued_date || null,
  });
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [groupInitValue, setGroupInitValue] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [timeData, setTimeData] = useState([]);
  const [practiceEnable, setPracticeEnable] = useState(
    Boolean(state.is_practice_enable),
  );
  const [imageList, setImageList] = useState([]);
  const handleGroupChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedGroup(typeof value === "string" ? value.split(",") : value);
  };

  const getGrpoupUpdatedData = (initGroup, updatedGroup) => {
    const dataToDelete = [];
    const dataToPost = [];

    initGroup.forEach((group) => {
      updatedGroup.indexOf(group) == -1 && dataToDelete.push(group);
    });

    updatedGroup.forEach((group) => {
      initGroup.indexOf(group) == -1 && dataToPost.push(group);
    });

    return { dataToDelete, dataToPost };
  };

  useEffect(() => {
    state.school_id &&
      getSchoolGroup(state.school_id)
        .then(({ data, status }) => {
          setGroupList(data);
          const initValue = data
            .filter((group) => {
              return group.grouped_users.find((user) => user.id == state.id);
            })
            .map((group) => group.id);
          setSelectedGroup(initValue);
          setGroupInitValue(initValue);
        })
        .then(() =>
          getStudentImage(state.id).then(({ data, status }) => {
            if (status === 200) {
              setImageList(data);
            }
          }),
        );
  }, []);

  const nav = useNavigate();

  const handleNavBack = () => nav("/user");

  const handleDelete = async () => {
    const isConfirmed = window.confirm(
      "Вы уверены что хотите удалить пользователя? Это действие невозможно отменить",
    );
    isConfirmed && (await deleteUser(state.id)) && handleNavBack();
  };

  const openRecoveryForm = () => {
    store.setForm(<PasswordResetFrom />, null, state);
  };

  const openPracticeForm = () => {
    store.setForm(() => {});
  };

  const fetchTimeData = () => {
    getDrivingTime(state.id).then(({ data }) => {
      setGridData(data);
    });
  };

  const handleRedactOpener = () => {};

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchTimeData();
  }, []);
  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setTimeData(e.data);
  };

  const handleAddOpener = async () => {
    const category = await getCategory();

    // const userCategories = category.status === 200 ? category.data.map((category)=>{

    // const isUserCategory = timeData.find(({category_id})=>Number( category_id) === Number(category.id))
    //   if(isUserCategory){
    //     return category
    //   }

    // }) : [];

    store.setForm(<DrivingTimeForm />, fetchTimeData, {
      ...timeData,
      user_id: state.id,
      categoryList: category.status === 200 ? category.data : [],
    });
  };

  const handleDeleteDrivingTime = () => {
    deleteDrivingTime(timeData.id, state.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        fetchTimeData();
        return;
      }
    });
  };

  return (
    <section className={Styles.user_redact_content}>
      <div className={Styles.user_nav}>
        <ArrowBackIcon onClick={handleNavBack} sx={{ cursor: "pointer" }} />
        <h6>
          Изменение пользователя: <strong>{state.name}</strong>
        </h6>
        {((state.is_delete || state.is_block) && (
          <Alert
            severity={
              (state.is_delete && "error") || (state.is_block && "warning")
            }
            style={{
              position: "static",
              margin: 0,
              alignSelf: "end",
              marginLeft: "auto",
            }}>
            {state.is_delete
              ? "Пользователь удален"
              : state.is_block
                ? "Пользователь заблокирован"
                : ""}
          </Alert>
        )) || <></>}
      </div>
      <div className={Styles.user_field_wrapper}>
        <Formik
          initialValues={{
            ...state,
            role: state.role || "",
            birthday: moment(state.birthday) || null,
          }}
          onSubmit={(values, { setSubmitting, isSubmitting }) => {
            setSubmitting(true);
            const groupUpdates = getGrpoupUpdatedData(
              groupInitValue,
              selectedGroup,
            );

            const deletedUsers = groupUpdates.dataToDelete.forEach(
              async (group) => {
                const userToGrup = await deleteUserToGroup(state.id, group);

                if (userToGrup.data != 200) {
                  return userToGrup.data;
                }
              },
            );

            if (deletedUsers) {
              setSubmitting(false);
              return store.setAlert("Искусcтвенная ошибка", "error");
            }

            const postedUsers = groupUpdates.dataToPost.forEach(
              async (group) => {
                const userToGrup = await postUserToGroup(state.id, group);

                if (userToGrup.status != 200) {
                  return userToGrup.data;
                }
              },
            );

            if (postedUsers) {
              setSubmitting(false);
              return store.setAlert(postedUsers, "error");
            }

            updateUser(
              {
                ...values,
                school_id: !!values.school_id ? values.school_id : null,
                birthday: dates.birthday,
                med_cert_issued_date: dates.med_cert_issued_date,
                passport_issued_date: dates.passport_issued_date,
              },
              state.id,
            ).then(({ data, status }) => {
              if (status === 200) {
                store.setAlert(data, "success");
                // handleNavBack();
                nav(`/user/${state.id}`, {
                  state: {
                    ...values,
                    birthday: dates.birthday
                      ? moment(dates.birthday).format("YYYY-DD-MM")
                      : null,
                    med_cert_issued_date: dates.med_cert_issued_date
                      ? moment(dates.med_cert_issued_date).format("YYYY-DD-MM")
                      : null,
                    passport_issued_date: dates.passport_issued_date
                      ? moment(dates.passport_issued_date).format("YYYY-DD-MM")
                      : null,
                  },
                });
                return;
              }

              store.setAlert(data, "error");
            });
            setSubmitting(false);
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            handleReset,
            submitForm,
            setFieldValue,
          }) => (
            <>
              <hr />
              <div className={Styles.user_field_area}>
                <p>Основная информация</p>
                <div
                  className={Styles.user_fields}
                  style={{ gridTemplateColumns: "1fr 1fr 1fr " }}>
                  <CustomField
                    name="name"
                    label={"ФИО пользователя"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    disabled={state.is_delete || state.is_block}
                  />
                  <CustomField
                    name="login"
                    label={"Номер телефона"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.login}
                    disabled={state.is_delete || state.is_block}
                  />
                  <CustomField
                    select
                    name="role"
                    label="Тип учетной записи"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.role}
                    disabled={state.is_delete || state.is_block}>
                    {Object.values(userRole)
                      .splice(1, 5)
                      .map((item, index) => (
                        <MenuItem value={index + 1}>{item}</MenuItem>
                      ))}
                  </CustomField>
                  <CustomField
                    select
                    name="school_id"
                    label="Автошкола"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.school_id}
                    disabled>
                    <MenuItem value={0}>Без автошколы</MenuItem>
                    {state.schoolList.map((school) => (
                      <MenuItem value={school.id}>"{school.name}"</MenuItem>
                    ))}
                  </CustomField>
                  <FormControl
                    margin="dense"
                    disabled={state.is_delete || state.is_block}>
                    <InputLabel id="demo-multiple-name-label">
                      Выбор группы в автошколе
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      multiple={state.role != 1}
                      onChange={(e) => {
                        if (e.target.value === "" && practiceEnable) {
                          const ungroupUserConfirm = window.confirm(
                            "При отчислении пользователя из группы доступ к практическим занятиям автоматически загрывается",
                          );

                          if (ungroupUserConfirm) {
                            handleGroupChange(e);
                            setPracticeEnable(false);
                            setFieldValue("is_practice_enable", 0);
                          }
                          return;
                        } else {
                          handleGroupChange(e);
                        }
                      }}
                      value={selectedGroup}
                      onBlur={handleBlur}
                      input={
                        <OutlinedInput
                          name="group"
                          onBlur={handleBlur}
                          label={"Выбор группы в автошколе"}
                          size="small"
                        />
                      }>
                      {state.role == 1 && (
                        <MenuItem value={""}>Не зачислен</MenuItem>
                      )}
                      {groupList.map((group) => (
                        <MenuItem value={group.id}>{group.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {state.role == 1 && (
                    <CustomField
                      helperText={
                        (selectedGroup.length === 0 || selectedGroup === "") &&
                        "Для изменения необходимо выбрать группу"
                      }
                      select
                      name="is_practice_enable"
                      label="Доступ к практическим занятиям"
                      onChange={(e) => {
                        handleChange(e);
                        setPracticeEnable(Boolean(e.target.value));
                      }}
                      onBlur={handleBlur}
                      disabled={
                        selectedGroup.length === 0 ||
                        state.is_delete ||
                        state.is_block
                      }
                      value={values.is_practice_enable}>
                      <MenuItem value={0}>Доступ закрыт</MenuItem>
                      <MenuItem value={1}>Доступ открыт</MenuItem>
                    </CustomField>
                  )}
                </div>
                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label={"Коментарий"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>
              <hr />
              {state.role == 1 && (
                <div className={Styles.user_field_area}>
                  <p>Документы</p>
                  <div className={Styles.user_fields}>
                    {/* <CustomField
                    
                  /> */}
                    <DatePicker
                      disabled={state.is_delete || state.is_block}
                      format="YYYY-MM-DD"
                      margin="dense"
                      maxDate={moment()}
                      label={"Дата рождения"}
                      onChange={(newValue) =>
                        setDates({
                          ...dates,
                          birthday: moment(newValue).format("YYYY-MM-DD"),
                        })
                      }
                      value={moment(dates.birthday)}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "date",
                          margin: "dense",
                        },
                      }}
                    />
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="registration_adres"
                      label={"Адрес регистрации"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.registration_adres}
                    />
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="living_adres"
                      label={"Адрес проживания"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.living_adres}
                    />{" "}
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="passport_seria"
                      label={"Серия паспорта"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.passport_seria}
                    />{" "}
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="passport_number"
                      label={"Номер паспорта"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.passport_number}
                    />{" "}
                    <DatePicker
                      disabled={state.is_delete || state.is_block}
                      format="YYYY-MM-DD"
                      margin="dense"
                      maxDate={moment()}
                      label={"Дата выдачи паспорта"}
                      onChange={(newValue) =>
                        setDates({
                          ...dates,
                          passport_issued_date:
                            moment(newValue).format("YYYY-MM-DD"),
                        })
                      }
                      value={moment(dates.passport_issued_date)}
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "date",
                          margin: "dense",
                        },
                      }}
                    />
                    {/* <CustomField
                    name="passport_issued_date"
                    label={"Дата выдачи паспорта"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.passport_issued_date}
                  />{" "} */}
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="passport_issued_by"
                      label={"Кем выдан паспорт"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.passport_issued_by}
                    />{" "}
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="work_adres"
                      label={"Место работы"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.work_adres}
                    />{" "}
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="studied_category"
                      label={"Имеющиеся категории"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.studied_category}
                    />
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="med_cert_number"
                      label={"Номер мед. справки"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.med_cert_number}
                    />
                    <CustomField
                      disabled={state.is_delete || state.is_block}
                      name="med_cert_issued_by"
                      label={"Кем выдана мед. справка"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.med_cert_issued_by}
                    />
                    <DatePicker
                      disabled={state.is_delete || state.is_block}
                      format="YYYY-MM-DD"
                      margin="dense"
                      maxDate={moment()}
                      label={"Дата выдачи мед.справки"}
                      onChange={(newValue) =>
                        setDates({
                          ...dates,
                          med_cert_issued_date:
                            moment(newValue).format("YYYY-MM-DD"),
                        })
                      }
                      value={
                        dates.med_cert_issued_date
                          ? moment(dates.med_cert_issued_date)
                          : null
                      }
                      slotProps={{
                        textField: {
                          size: "small",
                          placeholder: "date",
                          margin: "dense",
                        },
                      }}
                    />
                  </div>
                </div>
              )}

              <div className={Styles.user_redact_actions}>
                <Button
                  disabled={state.is_delete || state.is_block || isSubmitting}
                  variant="contained"
                  color="error"
                  onClick={handleDelete}>
                  Удалить
                </Button>
                <Button
                  variant="contained"
                  disabled={isSubmitting || state.is_delete}
                  onClick={() => {
                    values.is_block = Number(!values.is_block);
                    handleSubmit();
                  }}
                  color={values.is_block ? "default" : "warning"}>
                  {values.is_block ? "Разблокировать" : "Заблокировать"}
                </Button>
                <Button
                  variant="contained"
                  disabled={isSubmitting || state.is_delete || state.is_block}
                  onClick={openRecoveryForm}>
                  Восстановить пароль
                </Button>
                <Button
                  disabled={
                    !Object.values(touched).length ||
                    isSubmitting ||
                    state.is_delete ||
                    state.is_block
                  }
                  color="success"
                  variant="contained"
                  sx={{ marginLeft: "auto", justifySelf: "end" }}
                  onClick={handleSubmit}>
                  Сохранить
                </Button>
              </div>
            </>
          )}
        </Formik>
      </div>

      {state.role == 1 && (
        <div
          style={{
            display: " flex",
            flexDirection: " column",
            borderRadius: " 5px",
            gap: " 10px",
            padding: " 15px",
            minHeight: " 250px",
            margin: "5px",
            backgrounCcolor: " #fff",
            border: " 1px solid #dedede",
            marginBottom: "25px",
            marginTop: "25px",
          }}>
          <p>Фотографии документов</p>
          {imageList.length !== 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                gridTemplateRows: "1fr 1fr",
                alignContent: "center",
                justifyContent: "center",
              }}>
              {imageList.map(({ name }) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "0 auto",
                    width: "95%",
                  }}>
                  <a
                    target="_blank"
                    alt={name}
                    rel="noreferrer"
                    href={
                      baseUrl + "/image/student_file/" + name
                      // +
                      // "?jwt=" +
                      // getToken()
                    }>
                    <img
                      style={{
                        width: "100%",
                        height: "calc(auto - 32px)",
                        aspectRatio: "16 / 9",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                        boxSizing: "border-box",
                        border: "3px solid #dedede",
                        boxShadow: "0 3px 15px 0 rgba(0, 0, 0, .3)",
                      }}
                      // style={{
                      //   flex: 1,
                      //   display: "flex",
                      //   aspectRatio: "4 / 3 ",
                      //   height: "auto",
                      // }}
                      alt=""
                      src={
                        baseUrl +
                        "/image/student_file/" +
                        name +
                        "?jwt=" +
                        getToken()
                      }
                    />
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <p
              style={{
                alignSelf: "center",
                justifySelf: "center",
                margin: "auto",
              }}>
              Фото не добавлены
            </p>
          )}
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        {practiceEnable && (
          <>
            <h6>Часы практических занятий</h6>
            <GridToolBar
              filter={true}
              onAdd={state.is_delete || state.is_block ? null : handleAddOpener}
              onRefresh={
                state.is_delete || state.is_block ? null : fetchTimeData
              }
              onDelete={
                state.is_delete || state.is_block
                  ? null
                  : handleDeleteDrivingTime
              }
              onUpdate={
                state.is_delete || state.is_block ? null : handleRedactOpener
              }
              filterValue={quickFilterText}
              filterOnChange={setQuickFilterText}
              dataToAction={timeData}
            />
            <div style={{ height: 300, width: "100%" }}>
              <AgGridReact
                onGridReady={onGridReady}
                onRowClicked={rowClickHandler}
                gerRowId={getRowId}
                rowData={gridData}
                defaultColDef={defaultColDef}
                tooltipShowDelay={500}
                rowSelection={rowSelection}
                columnDefs={[...DrivingTimeColumn]}
                getRowStyle={getUserRowStyle}
              />
            </div>
          </>
        )}
      </div>

      {(state.role == 1 || state.role == 5) && (
        <ReactCalendar
          customCategories={gridData.map(({ category_id, name }) => {
            return { id: category_id, name };
          })}
          currentSchoolId={state.school_id}
          practiceEnable={
            !!state.is_delete
              ? false
              : !!state.is_block
                ? false
                : practiceEnable
          }
          currentStudent={state.role == 1 && state}
          currentTeacher={state.role == 5 && state}
        />
      )}
    </section>
  );
}
